import React from 'react';
import Particles from "react-tsparticles";

const ParticlesContainer = () => {

    return (
        <Particles
            id="tsparticles"
            options={{
                fpsLimit: 60,
                interactivity: {
                    detectsOn: "canvas",
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "bubble",
                        },
                        resize: true,
                    },
                    modes: {
                        bubble: {
                            distance: 400,
                            duration: 2,
                            opacity: 0.8,
                            size: 20,
                        },
                        push: {
                            quantity: 4,
                        }
                    },
                },
                particles: {
                    color: {
                        value: ['#ef476f', '#06d6a0', '#118ab2', '#ffd166'],
                    },
                    links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: true,
                    },
                    move: {
                        direction: "none",
                        enable: true,
                        outMode: "bounce",
                        random: false,
                        speed: 6,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            value_area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        random: true,
                        value: 8,
                    },
                },
                detectRetina: true,
            }}
        />
    )
}

export default ParticlesContainer